// Read from window.env (injected at runtime) or fall back to import.meta.env (for local dev/build)
declare global {
  interface Window {
    env?: {
      VITE_APP_VERSION?: string;
      VITE_APP_NAMESPACE?: string;
      VITE_SENTRY_RELEASE_NAME?: string;
    };
  }
}

const getEnvVar = (
  key: "VITE_APP_VERSION" | "VITE_APP_NAMESPACE" | "VITE_SENTRY_RELEASE_NAME",
): string => {
  // Try window.env first (runtime injection)
  if (typeof window !== "undefined" && window.env?.[key]) {
    return window.env[key];
  }
  // Fall back to import.meta.env (build-time or local dev)
  return import.meta.env[key] || "undefined";
};

export const APP_VERSION = getEnvVar("VITE_APP_VERSION");
export const APP_NAMESPACE = getEnvVar("VITE_APP_NAMESPACE");
export const SENTRY_RELEASE_NAME = getEnvVar("VITE_SENTRY_RELEASE_NAME");
export const VITEST = import.meta.env.VITEST === "true" || false;
